import ROUTES from "@consts/routes";
import i18n from "@/lang/i18n";

const routerView = {
  render(c) {
    return c("router-view");
  }
}
export default [
  {
    path: 'bookings',
    name: ROUTES.HOTEL.BOOKING_LIST,
    meta: {
      breadcrumb: i18n.tc('breadcrumbs.Booking'),
      activeKey: 'hotel.booking.list'
    },
    component: routerView,
    children: [
      {
        path: '',
        name: ROUTES.HOTEL.BOOKING_LIST,
        meta: {
          activeKey: 'hotel.booking.list'
        },
        component: () => import("@components/hotel/bookings/ListBooking"),
      },
      {
        path: ':id/edit',
        name: ROUTES.HOTEL.BOOKING_EDIT,
        meta: {breadcrumb: i18n.tc('breadcrumbs.Booking edit'), activeKey: 'hotel.booking.list'},
        component: () => import("@components/hotel/bookings/BookingEdit"),
      },
      {
        path: 'history/:id',
        name: ROUTES.HOTEL.BOOKING_HISTORY_LIST,
        meta: {breadcrumb: i18n.tc('breadcrumbs.Booking history'), activeKey: 'hotel.booking.list'},
        component: () => import("@components/hotel/bookings/ListBookingHistory"),
      },
    ]
  },
];
